<template lang="pug">
.c-article-list
  ul(:class='$style.list')
    li(v-for="item in items"
      :class="$style.item"
      @click="$emit('select', item)")
      h3(:class="$style.title") {{ item.title }}
      b-icon(:class="$style.calendar"
        pack="fas"
        icon="calendar-alt"
        type="is-grey")
      div(:class="$style.time")
        span {{ item.eventTime ? new Date(item.eventTime).toLocaleDateString() : '' }}
</template>

<script>
export default {
  name: "ArticleList",
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    getTimeString(sec) {
      return new Date(sec * 1000).toLocaleDateString();
    },
  },
};
</script>

<style module lang="sass">
.list
  border: 1px solid $grey-lighter
  border-radius: 6px
.item
  +flexbox
  +pointer
  padding: pxRem(12)
  h3
    font-weight: bold
  &:nth-child(even)
    background-color: $white-ter
  &:hover
    background-color: $warning
.title
  +ellipsis
  flex: 1
.calendar
  flex: 0 1
  padding: 0 pxRem(16)
  display: none !important
  +tablet
    display: inline-flex !important
.time
  +flexbox(flex-start, center)
  align-self: stretch
  flex: 0 1 pxRem(70)
  color: $grey
  font-size: $size-7
  font-weight: bold
  display: none !important
  +tablet
    display: inline-flex !important
</style>
